import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsGuardService implements CanActivate,CanActivateChild {
  public constructor(public auth: AuthService, public router: Router) { }
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if(childRoute.routeConfig.path==""){
      return true;
    }
    const childLength=childRoute.routeConfig.path.split('/').length;
    const parentLength=state.url.split('/').length;
    const newUrl:string=state.url.split('/').slice(0,parentLength-childLength).join('/');
    return this.checkUrlForPermission(newUrl).then((el)=>{
      if (!el) {
        this.router.navigate(['/']);
      }
      return el
    }).catch(()=>{
      this.router.navigate(['/login']);
      return false
    });
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.checkUrlForPermission(state.url).then((el)=>{
      if (!el) {
        this.router.navigate(['/']);
      }
      return el
    }).catch(()=>{
      this.router.navigate(['/login']);
      return false
    });
  }
  private async checkUrlForPermission(inputUrl:string){
    const role = await this.auth.getRole();

    const hasPermission = role.Permissions.filter((permission: any) => {
      const clientURL = permission.clientURL ?? "";
      const lastCharIndex = clientURL.length - 1 ;
      const clientLastChar = clientURL[lastCharIndex] ?? "";

      if(clientLastChar !== "&") return clientURL === inputUrl;
      const subClientURL = permission.clientURL.substr(0, lastCharIndex);
      const subInputUrlArr = inputUrl.split("/"); subInputUrlArr.pop();
      const subInputUrl = subInputUrlArr.join("/");
      return subClientURL.includes(subInputUrl);
    });
    if (this.auth.isAuthenticated() && hasPermission.length) {
      return true;
    } else {
      console.log(inputUrl);
      return false;
    }
  }
}
